export type UpgradeData = {
  name: string;
  factions: string[];
  requires: string[];
  cost: number;
  time: number;
  power: number;
  weapon?: string;
};

export const upgrades: Record<string, UpgradeData> = {
  turbine: {
    name: "Turbine",
    factions: ["bastion"],
    requires: ["radar"],
    cost: 400,
    time: 10,
    power: 4,
  },
};
